module.exports = __webpack_public_path__ + "img/info_small.004a0646.svg";